/**
 * Задеркжа перед вызовом invalidateSize для карты
 */
export const MAP_RESIZE_DELAY = 200;
